export default "__VITE_PUBLIC_ASSET__39f3a558__"